import { useNavigate } from 'react-router-dom'

const HeaderLogoSection = () => {
    const navigate = useNavigate();
    
    return (
        <nav className="navbar navbar-expand-sm sticky-top bg-menu-dark justify-content-between reset">
            <div className="container content-logo">
                <img className="img-fluid" src="images/logo/halifax-consulting.svg" alt="" onClick={()=>navigate('/')}/>
            </div>
        </nav>
    );
}

export default HeaderLogoSection;